import {
  deepPurple,
  orange,
  pink,
  grey,
  teal,
  yellow,
} from "@mui/material/colors";

export const taskPropertiesColors = [
  "#397EE3",
  "#3A50AC",
  deepPurple[300],
  "#5644CE",
  "#9034A7",
  teal[300],
  "#4D9568",
  "#35786F",
  yellow[700],
  orange[500],
  "#DC682A",
  pink[200],
  pink[300],
  "#EB2213",
  "#646464",
  "#8D8D8D",
];

export const taskPropertyColorByDefault = grey[400];
